<template>
  <div class="step-2">
    <div class="container--md mx-auto text-center my-3">
      <img :src="logoUrl" alt="" class="mw-100" />
      <ProgressBar progress="75" label="3 / 4" />
    </div>

    <div v-if="id && name">
      <section class="background--waves">
        <div class="background--waves__second">
          <div class="card">
            <div class="px-2 px-sm-0">
              <h3>{{ textSurpriseTitle }}</h3>
              <h2 class="mb-4">{{ textChance }}</h2>
              <h1>{{ name }}</h1>
            </div>

            <div class="col-sm-10 col-md-8 mx-auto">
              <div v-html="getProductImageHtml()" class="my-4"></div>

              <div class="row">
                <div class="col-6 title">{{ productName }}</div>
                <div class="col-6 text-right">
                  (127)
                  <div class="review-5star d-inline-block" :style="{ width: 5 * 20 + 'px' }">
                    <img :src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
                  </div>
                </div>
              </div>

              <div class="description mt-4" v-html="splashDescription"></div>

              <div class="people w-100 my-3">
                👁
                <span :class="{ opacityTransition: showPeopleOnline }">{{ peopleViewing }}</span>
                {{ $t("checkout.users_online") }}
              </div>

              <AmountSelector :list="selectList" :prices="upsellPrices" v-model="quantity" v-if="!isVirtual" />

              <div @click="add(quantity)" class="red-button mt-4">
                <div class="d-flex">
                  <img :src="$root.cdn_url + '/assets/images/upsells/cart.svg'" class="mr-2" alt="" />
                  <div>{{ textAdd }}</div>
                </div>
              </div>

              <p class="no">
                <a @click="$emit('skip')">
                  {{ $t("upsells.cancel.full") }}
                </a>
              </p>
            </div>
          </div>

          <div class="container container--lg mt-5 d-none d-sm-block">
            <div class="row">
              <div v-for="(review, id) of reviews" :key="'review' + id" class="col-sm-6">
                <div class="review d-flex mt-3 mx-sm-2">
                  <div>
                    <div class="review__avatar">
                      <img :src="review.image" alt="" />
                    </div>
                    <div class="review-5star" :style="{ width: review.rate * 20 + 'px' }">
                      <img :src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
                    </div>
                  </div>
                  <div class="pl-3 w-100">
                    <div class="review__header d-flex justify-content-between">
                      <div class="review__verified">
                        <img class="lazy mr-2" :data-src="$root.cdn_url + '/assets/images/zmc10/check.svg'" />
                        {{ $t("reviews.verified") }}
                      </div>
                      <div class="text-align-right">
                        {{ review.name }}
                      </div>
                    </div>
                    <div class="mt-2 review__text">"{{ review.text }}"</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="container container--sm">
        <h2>{{ homeName }}</h2>

        <div v-for="(feature, id) in headerFeatures" :key="'feature' + id" class="d-flex mb-1">
          <img :src="$root.cdn_url + '/assets/images/upsells/check-circle-green.svg'" class="mr-2" />
          <span v-html="feature"></span>
        </div>

        <div class="container d-block d-sm-none">
          <div v-for="(review, id) of reviews" :key="'review' + id">
            <div class="review d-flex mt-3 mx-sm-2">
              <div>
                <div class="review__avatar">
                  <img :src="review.image" alt="" />
                </div>
                <div class="review-5star" :style="{ width: review.rate * 20 + 'px' }">
                  <img :src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
                </div>
              </div>
              <div class="pl-3 w-100">
                <div class="review__header d-flex justify-content-between">
                  <div class="review__verified">
                    <img class="lazy mr-2" :data-src="$root.cdn_url + '/assets/images/zmc10/check.svg'" />
                    {{ $t("reviews.verified") }}
                  </div>
                  <div class="text-align-right">
                    {{ review.name }}
                  </div>
                </div>
                <div class="mt-2 review__text" v-html="review.text"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-10 mx-auto">
            <AmountSelector :list="selectList" :prices="upsellPrices" v-model="quantity" v-if="!isVirtual" />

            <div @click="add(quantity)" class="red-button mt-4">
              <div class="d-flex">
                <img :src="$root.cdn_url + '/assets/images/upsells/cart.svg'" class="mr-2" alt="" />
                <div>{{ textAdd }}</div>
              </div>
            </div>

            <img :src="$root.cdn_url + '/assets/images/zmc10/partners.png'" class="w-100 my-3 mx-auto d-block" style="max-width: 395px" />
          </div>
        </div>
      </section>
    </div>
    <div v-else class="text-center m-5">
      <Spinner />
    </div>

    <p class="no">
      <a @click="$emit('skip')">
        {{ $t("upsells.cancel.full") }}
      </a>
    </p>
  </div>
</template>

<script>
import { t } from "../../utils/i18n";
import upsells from "../../mixins/upsells";
import { getUppSells } from "../../services/upsells";
import Spinner from "../common/preloaders/Spinner";
import ProgressBar from "./ProgressBar";
import AmountSelector from "./AmountSelector";

export default {
  name: "Step2",

  mixins: [upsells],

  props: ["id", "discount", "accessoryStep"],

  components: { Spinner, ProgressBar, AmountSelector },

  data: () => ({
    upsellPrices: {},
    description: null,
    splashDescription: null,
    homeName: null,
    productName: null,
    finalPrice: null,
    finalPricePure: null,
    name: null,
    price: null,
    priceFormatted: null,
    imageUrl: null,
    gifImageUrl: null,
    vimeoId: null,
    videoFile: null,
    isVirtual: false,
    isLoading: false,
    peopleViewing: 0,
    showPeopleOnline: true,
    quantity: 1,
    logoUrl: null
  }),

  computed: {
    textSurpriseTitle() {
      return this.$t("upsells.surprise_title", { NAME: js_data.order_customer.customer_first_name || localStorage.getItem("stripe_username") || "" });
    },
    textChance() {
      return this.$t("upsells.add_to_order.no_discount", { PRODUCT: this.productName, DISCOUNT: this.upsellPrices.discount_percent + "%" });
    },
    textCustomersReviews() {
      return this.$t("upsells.customers_reviews", { PRODUCT: this.name });
    },
    textAdd() {
      return this.$t("upsells.yes_add", { PRODUCT: this.productName });
    },

    selectList() {
      const data = Object.keys(this.upsellPrices)
        .filter(key => parseInt(key) > 0 && parseInt(key) <= this.getAllowedUpsellQty())
        .map(key => {
          return {
            label: `${key}x ${this.name} - ${this.upsellPrices[key].price_text}`,
            text: `${key}x ${this.name} - ${this.upsellPrices[key].price_text}`,
            value: key
          };
        });

      return data;
    },

    // process HTML description to pull features highlights
    headerFeatures() {
      var features = [];
      var el = document.createElement("html");
      el.innerHTML = this.description;
      for (let li of el.getElementsByTagName("li")) {
        features.push(li.innerHTML);
      }
      return features;
    }
  },

  mounted() {
    this.isLoading = true;

    if (!this.id) {
      return;
    }

    getUppSells(this.id, this.getAllowedUpsellQty() || 1, this.accessoryStep)
      .then(res => {
        if (res && res.data) {
          this.upsellPrices = res.data.upsell.upsellPrices;
          this.name = res.data.upsell.long_name;
          this.homeName = res.data.upsell.home_name;
          this.productName = res.data.upsell.product_name;
          this.splashDescription = res.data.upsell.splash_description;
          this.reviews = res.data.upsell.reviews ? res.data.upsell.reviews.slice(0, 2) : [];

          this.description = res.data.upsell.description;

          this.imageUrl = res.data.upsell.image;
          this.gifImageUrl = res.data.upsell.gif_image;
          this.vimeoId = res.data.upsell.vimeo_id;
          this.videoFile = res.data.upsell.video_file;
          this.priceFormatted = (this.upsellPrices["1"] && this.upsellPrices["1"].price_text) || "";
          this.price = (this.upsellPrices["1"] && this.upsellPrices["1"].price) || 0;
          this.finalPrice = (this.upsellPrices["1"] && this.upsellPrices["1"].price_text) || "";
          this.finalPricePure = (this.upsellPrices["1"] && this.upsellPrices["1"].price) || 0;
          this.isVirtual = res.data.upsell.type === "virtual";
        }
      })
      .then(() => {
        this.isLoading = false;
      });
  },

  methods: {
    generatePeopleCount() {
      return Math.floor(Math.random() * 50 + 50);
    },

    add(quantity) {
      quantity = +quantity;

      this.finalPrice = (this.upsellPrices && this.upsellPrices[quantity] && this.upsellPrices[quantity].price_text) || "";
      this.finalPricePure = (this.upsellPrices && this.upsellPrices[quantity] && this.upsellPrices[quantity].price) || 0;

      this.addToCart(quantity);
    }
  },

  created() {
    this.peopleViewing = this.generatePeopleCount();
    this.logoUrl = js_data.product.logo_image;

    setInterval(() => {
      this.showPeopleOnline = false;
      // toggle animation class with delay to make animation
      setTimeout(() => {
        this.peopleViewing = this.generatePeopleCount();
        this.showPeopleOnline = true;
      }, 100);
    }, 7000);
  }
};
</script>

<style lang="scss">
.upsells-component {
  .step-2 {
    .container--sm {
      max-width: 580px;
    }

    h1 {
      font-weight: 500;
      font-size: 21px;
      line-height: 25px;
      text-align: center;
      color: #333333;
    }

    h2 {
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      text-align: center;
      color: #333333;
    }

    h3 {
      font-style: normal;
      font-weight: bold;
      font-size: 21px;
      line-height: 25px;
      text-align: center;
      padding: 10px;
      color: #ffffff;
      background: #0089cc;
      border-radius: 5px;
    }

    .title {
      font-weight: bold;
      font-size: 24px;
      line-height: 31px;
      color: #333333;
    }

    .description {
      font-size: 21px;
      line-height: 25px;
      color: #3e3e3e;
    }

    .people {
      background: #faf7f7;
      border: 2px solid #c5c5c5;
      border-radius: 3px;
      padding: 12px 5px;
      font-size: 17px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.5px;
      color: #4e4e4e;

      span {
        opacity: 0;
      }

      .opacityTransition {
        opacity: 1 !important;
        transition: all 1s;
      }
    }

    .card {
      background: #fefefe;
      box-shadow: 0px 3px 10px 6px rgba(16, 56, 107, 0.1);
      max-width: 747px;
      margin: auto;
      padding: 40px 14px;
    }

    .review {
      flex-direction: row;
      padding: 0;
      border-top: 0;
      font-family: Roboto, Arial, Helvetica, sans-serif;

      &__header {
        font-size: 14px;
      }

      &__avatar {
        height: 64px;
        overflow: hidden;

        & > img {
          width: 93px;
          border-radius: 50%;
          margin-top: -15px;
          padding: 3px;
          border: 1px solid rgb(181, 181, 181);
        }
      }

      &__verified {
        color: #4bad00;
      }

      &__text {
        font-size: 16px;
      }
    }

    .no {
      color: #0c0c0c;
    }

    @media screen and (max-width: 767px) {
      .card {
        padding: 20px 0;
        box-shadow: none;
        border: 0;
      }
    }
  }
}
</style>
